import type { EditorThemeClasses } from "lexical";

export const theme: EditorThemeClasses = {
    ltr: "rte-ltr",
    rtl: "rte-rtl",
    paragraph: "rte-paragraph",
    quote: "rte-quote",
    heading: {
        h1: "rte-heading-h1",
        h2: "rte-heading-h2",
        h3: "rte-heading-h3",
        h4: "rte-heading-h4",
        h5: "rte-heading-h5",
        h6: "rte-heading-h6",
    },
    list: {
        nested: { listitem: "rte-nested-listitem" },
        ol: "rte-list-ol",
        ul: "rte-list-ul",
        listitem: "rte-listitem",
    },
    link: "rte-link",
    text: {
        bold: "rte-text-bold",
        italic: "rte-text-italic",
        underline: "rte-text-underline",
        strikethrough: "rte-text-strikethrough",
        underlineStrikethrough: "rte-text-underline-strikethrough",
        code: "rte-text-code",
        highlight: "rte-text-highlight",
    },
    table: "rte-table",
    tableCell: "rte-table-cell",
    tableCellHeader: "rte-table-cell-header",
    tableRow: "rte-table-row",
};
